export default function NewsletterForm() {
  return null;
}

export const BlogNewsletterForm = () => null;
